import { contentMap } from './content-map';
import { create } from './create';
import { getOne } from './get-one';
import { getPopularForAdmin } from './get-popular-for-admin';
import { query } from './query';
import { refreshGuide } from './refresh-guide';
import { refreshLocalization } from './refresh-localization';
import { remove } from './remove';
import { update } from './update';

type ApiDeclaration = {
    create: typeof create;
    getOne: typeof getOne;
    update: typeof update;
    query: typeof query;
    remove: typeof remove;
    refreshLocalization: typeof refreshLocalization;
    refreshGuide: typeof refreshGuide;
    getPopularForAdmin: typeof getPopularForAdmin;
    contentMap: typeof contentMap;
};

export const citiesApiDeclaration: ApiDeclaration = {
    create,
    getOne,
    update,
    query,
    remove,
    refreshLocalization,
    refreshGuide,
    getPopularForAdmin,
    contentMap,
};
